/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../_metronic/helpers'
import {Link, useNavigate} from 'react-router-dom'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import swal from 'sweetalert'
import {
  synchroCustomer,
  synchroMaterial,
  synchroPlant,
  synchroSalesArea,
  synchroSalesOffice,
  getPlant,
  getAreaAll,
  synchroMaterialParam,
  synchroStorLoc,
  synchroBankKey,
} from '../../../api/modules/synchronize'
import {
  getMaterialAll,
  getOfficeAll,
  getCustomerAll,
  getSlocAll,
  getBankKey,
} from '../../../api/modules/master-data/master'
import {useTranslation, initReactI18next} from 'react-i18next'
import axios from 'axios'
import Pagination from '../component/Pagination'
import {Dropdown} from 'react-bootstrap'
import {Spinner} from 'react-bootstrap'
import {PopoverText} from '../../../components/Popover/Popover'
import {SkeletonForm} from 'src/components/Skeletons'
import {AppButton} from 'src/components'
import { syncSupplyPoint } from 'src/services/fetcher'

type Props = {
  className: string
}

const Synchronize: React.FC<Props> = ({className}) => {
  const navigate = useNavigate()
  const {t} = useTranslation()

  const credentials = localStorage.getItem('credential')

  const [tooltip, setTooltip] = useState('Open')
  const handleOpen = (e: any) => {
    const icon = e.target
    if (icon.classList.contains('iconArow')) {
      icon?.classList.remove('iconArow')
      icon?.classList.add('iconArowOpen')
      setTooltip('Close')
    } else {
      icon?.classList.remove('iconArowOpen')
      icon?.classList.add('iconArow')
      setTooltip('Open')
    }
    const target = e.currentTarget.getAttribute('data-target')
    const fold = document.getElementById(target)
    fold?.classList.toggle('fold-open')
  }

  const [loading, setLoading] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [modaltype, setModaltype] = useState('')
  const [allPlant, setAllPlant] = useState<any[]>([])
  const [allArea, setAllArea] = useState<any[]>([])
  const [allMaterial, setAllMaterial] = useState<any[]>([])
  const [allOffice, setAllOffice] = useState<any[]>([])
  const [allCustomer, setAllCustomer] = useState<any[]>([])
  const [allStorLoc, setAllStorLoc] = useState<any[]>([])
  const [allBankKey, setAllBankKey] = useState<any[]>([])
  const [page, setPage] = useState(0)
  const [per, setPer] = useState(0)
  const [numberURL, setNumberURL] = useState([])
  const [showApprove, setShowApprove] = useState(false)
  const [funcState, setFuncState] = useState<any>()
  const [showMatNumber, setShowMatNumber] = useState(false)
  const [matNum, setMatNum] = useState<any>('')
  const [showMatDate, setShowMatDate] = useState<any>(false)
  const [matDate1, setMatDate1] = useState<any>('')
  const [matDate2, setMatDate2] = useState<any>('')
  const [showSkeletonModal, setShowSkeletonModal] = useState(false)
  const [isLoadingApproval, setIsLoadingApproval] = useState(false)

  //#region
  const plantSynchro = async () => {
    setBtnLoading(true)
    await synchroPlant()
      .then((res) => {
        swal({
          title: `${t('plant syncronized')}`,
          icon: 'success',
        })
        setBtnLoading(false)
      })
      .catch(function (error) {
        setBtnLoading(false)
        if (error.response) {
          swal({
            title: `${t(error.response.data.message)}`,
            icon: 'error',
          })
        }
      })
  }

  const areasynchro = async () => {
    setBtnLoading(true)
    await synchroSalesArea()
      .then((res) => {
        swal({
          title: `${t('Sales Area syncronized')}`,
          icon: 'success',
        })
        setBtnLoading(false)
      })
      .catch(function (error) {
        setBtnLoading(false)
        if (error.response) {
          swal({
            title: `${t(error.response.data.message)}`,
            icon: 'error',
          })
        }
      })
  }

  const officesynchro = async () => {
    setBtnLoading(true)
    await synchroSalesOffice()
      .then((res) => {
        swal({
          title: `${t('Sales Office syncronized')}`,
          icon: 'success',
        })
        setBtnLoading(false)
      })
      .catch(function (error) {
        setBtnLoading(false)
        if (error.response) {
          swal({
            title: `${t(error.response.data.message)}`,
            icon: 'error',
          })
        }
      })
  }

  const materialsynchro = async () => {
    setBtnLoading(true)
    await synchroMaterial()
      .then((res) => {
        swal({
          title: `${t(res.data.message)}`,
          icon: 'success',
        })
        setBtnLoading(false)
      })
      .catch(function (error) {
        setBtnLoading(false)
        if (error.response) {
          swal({
            title: `${t(error.response.data.message)}`,
            icon: 'error',
          })
        }
      })
  }

  const materialsynchroParam = async (mat: any = '', date1: any = '', date2: any = '') => {
    setBtnLoading(true)
    await synchroMaterialParam(mat, date1, date2)
      .then((res) => {
        swal({
          title: `${t(res.data.message)}`,
          icon: 'success',
        })
        setBtnLoading(false)
      })
      .catch((error) => {
        setBtnLoading(false)
        if (error.message === 'Network Error') {
          swal({
            closeOnClickOutside: false,
            title: 'Gateway Timeout',
            icon: 'error',
          })
        } else {
          swal({
            title: `${t(error.response.data.message)}`,
            icon: 'error',
          })
        }
      })
  }

  const customersyncrho = async () => {
    setBtnLoading(true)
    await synchroCustomer()
      .then((res) => {
        swal({
          title: `${t(res.data.message)}`,
          icon: 'success',
        })
        setBtnLoading(false)
      })
      .catch(function (error) {
        setBtnLoading(false)
        if (error.response) {
          swal({
            title: `${t(error.response.data.message)}`,
            icon: 'error',
          })
        }
      })
  }

  const storLocSyncrho = async () => {
    setBtnLoading(true)
    await synchroStorLoc()
      .then((res) => {
        swal({
          title: `${t(res.data.message)}`,
          icon: 'success',
        })
        setBtnLoading(false)
      })
      .catch((error) => {
        setBtnLoading(false)
        if (error.message === 'Network Error') {
          swal({
            closeOnClickOutside: false,
            title: 'Gateway Timeout',
            icon: 'error',
          })
        } else {
          swal({
            title: `${t(error.response.data.message)}`,
            icon: 'error',
          })
        }
      })
  }

  const bankKeySyncrho = async () => {
    setBtnLoading(true)
    await synchroBankKey(cusDate, cusDatee)
      .then((res) => {
        swal({
          title: `${t(res.data.message)}`,
          icon: 'success',
        })
        setBtnLoading(false)
        setShowBank(false)
      })
      .catch((error) => {
        setBtnLoading(false)
        if (error.message === 'Network Error') {
          swal({
            closeOnClickOutside: false,
            title: 'Gateway Timeout',
            icon: 'error',
          })
        } else {
          swal({
            title: `${t(error.response.data.message)}`,
            icon: 'error',
          })
        }
      })
  }

  const approvesynchro = async (func: any) => {
    setIsLoadingApproval(true)

    try {
      switch (func) {
        case 'plant':
          await plantSynchro()
          break
        case 'area':
          await areasynchro()
          break
        case 'material':
          await materialsynchro()
          break
        case 'office':
          await officesynchro()
          break
        case 'customer':
          await customersyncrho()
          break
        case 'Storage Location':
          await storLocSyncrho()
          break
        case 'Bank Key':
          await bankKeySyncrho()
          break
        default:
          break
      }

      setIsLoadingApproval(false)
      setShowApprove(false)
    } catch (error: any) {
      swal({
        closeOnClickOutside: false,
        title: t(error.response.data.message) ?? 'Internal server error',
        icon: 'error',
      })
    }
  }
  //#endregion

  //#region
  const plantTable = () => {
    setShowSkeletonModal(true)
    setModaltype('Plant')
    getPlant().then((res) => {
      setAllPlant(res.data.data.data)
      setNumberURL(res.data.data.links)
      setShowModal(true)
      setShowSkeletonModal(false)
    })
  }

  const areaTable = () => {
    setShowSkeletonModal(true)
    setModaltype('Sales Area')
    getAreaAll().then((res) => {
      setAllArea(res.data.data.data)
      setNumberURL(res.data.data.links)
      setShowModal(true)
      setShowSkeletonModal(false)
    })
  }

  const materialTable = () => {
    setShowSkeletonModal(true)
    setModaltype('Material Product')
    getMaterialAll('').then((res) => {
      setAllMaterial(res.data.data.data)
      setNumberURL(res.data.data.links)
      setShowModal(true)
      setShowSkeletonModal(false)
    })
  }

  const officeTable = () => {
    setShowSkeletonModal(true)
    setModaltype('Sales Office')
    getOfficeAll('').then((res) => {
      setAllOffice(res.data.data.data)
      setNumberURL(res.data.data.links)
      setShowModal(true)
      setShowSkeletonModal(false)
    })
  }

  const customerTable = () => {
    setShowSkeletonModal(true)
    setModaltype('Customer')
    getCustomerAll('').then((res) => {
      setAllCustomer(res.data.data.data)
      setNumberURL(res.data.data.links)
      setShowModal(true)
      setShowSkeletonModal(false)
    })
  }

  const storLocTable = () => {
    setShowSkeletonModal(false)
    setModaltype('Storage Location')
    getSlocAll().then((res) => {
      setAllStorLoc(res.data.data.data)
      setNumberURL(res.data.data.links)
      setShowModal(true)
      setShowSkeletonModal(false)
    })
  }

  const [filterBankKeyId, setFilterBankKeyId] = useState('')
  const [filterBankKeyKey, setFilterBankKeyKey] = useState('')
  const [filterBankKeyName, setFilterBankKeyName] = useState('')
  const [filterBankKeyCity, setFilterBankKeyCity] = useState('')
  const [filterBankKeyRegion, setFilterBankKeyRegion] = useState('')
  const [filterBankKeyCountry, setFilterBankKeyCountry] = useState('')

  const loadBankKey = () => {
    getBankKey({
      id: filterBankKeyId,
      bank_key: filterBankKeyKey,
      bank_name: filterBankKeyName,
      city: filterBankKeyCity,
      region_desc: filterBankKeyRegion,
      country: filterBankKeyCountry
    }).then((res) => {
      setAllBankKey(res.data.data.data)
      setNumberURL(res.data.data.links)
    })
  }

  const bankKeyTable = () => {
    setShowSkeletonModal(false)
    setModaltype('Bank Key')
    setShowModal(true)
    loadBankKey()
  }

  useEffect(() => {
    loadBankKey()
  }, [
    filterBankKeyId,
    filterBankKeyKey,
    filterBankKeyName,
    filterBankKeyCity,
    filterBankKeyRegion,
    filterBankKeyCountry
  ])

  const paginateNumberPlant = async (number: any) => {
    setLoading(true)
    await axios
      .get(number, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      })
      .then((res) => {
        setAllPlant(res.data.data.data)
        setPage(res.data.data.current_page)
        setPer(res.data.data.per_page)
        setLoading(false)
        setNumberURL(res.data.data.links)
      })
  }

  const paginateNumberArea = async (number: any) => {
    setLoading(true)
    await axios
      .get(number, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      })
      .then((res) => {
        setAllArea(res.data.data.data)
        setPage(res.data.data.current_page)
        setPer(res.data.data.per_page)
        setLoading(false)
        setNumberURL(res.data.data.links)
      })
  }
  const paginateNumberMaterial = async (number: any) => {
    setLoading(true)
    await axios
      .get(number, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      })
      .then((res) => {
        setAllMaterial(res.data.data.data)
        setPage(res.data.data.current_page)
        setPer(res.data.data.per_page)
        setLoading(false)
        setNumberURL(res.data.data.links)
      })
  }

  const paginateNumberOffice = async (number: any) => {
    setLoading(true)
    await axios
      .get(number, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      })
      .then((res) => {
        setAllOffice(res.data.data.data)
        setPage(res.data.data.current_page)
        setPer(res.data.data.per_page)
        setLoading(false)
        setNumberURL(res.data.data.links)
      })
  }

  const paginateNumberCustomer = async (number: any) => {
    setLoading(true)
    await axios
      .get(number, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      })
      .then((res) => {
        setAllCustomer(res.data.data.data)
        setPage(res.data.data.current_page)
        setPer(res.data.data.per_page)
        setLoading(false)
        setNumberURL(res.data.data.links)
      })
  }

  const paginateBankKey = async (number: any) => {
    console.log("chanhed", number)
    setLoading(true)
    await axios
      .get(number, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      })
      .then((res) => {
        setAllBankKey(res.data.data.data)
        setPage(res.data.data.current_page)
        setPer(res.data.data.per_page)
        setLoading(false)
        setNumberURL(res.data.data.links)
      })
  }
  //#endregion

  const [showCus, setShowCus] = useState(false)
  const [showCusDate, setShowCusDate] = useState(false)
  const [showBank, setShowBank] = useState(false)
  const handleCloseCus = () => setShowCus(false)
  const handleShowCus = () => setShowCus(true)
  const handleCloseCusDate = () => {
    setShowCusDate(false)
    setCusDate('')
    setCusDatee('')
  }
  const handleShowCusDate = () => setShowCusDate(true)
  const [btnLoading, setBtnLoading] = useState(false)

  const [cusCode, setCusCode] = useState<any>()
  const [cusDate, setCusDate] = useState<any>('')
  const [cusDatee, setCusDatee] = useState<any>('')

  const handleAddCus = async () => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setBtnLoading(true)
        axios
          .post(
            `${process.env.REACT_APP_PI_BACKEND_API_MASTERDATA}/syncronize/customer?credentials=${credentials}`,
            {
              customer_code: cusCode,
              low_date: cusDate,
              high_date: cusDatee,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
                Accept: 'application/json',
                'Access-Control-Allow-Origin': '*',
              },
            }
          )
          .then((res) => {
            swal({
              title: t('Custemer is already syncronized!'),
              icon: 'success',
            }).then(() => {
              setBtnLoading(false)
              setShowCus(false)
              setShowCusDate(false)
              getCustomerAll()
            })
          })
          .catch((err) => {
            setBtnLoading(false)
            swal({
              title: err?.response?.data?.message || t('failed'),
              icon: 'error',
            })
          })
      }
    })
  }

  const [loadingSync, setLoadingSync] = useState(false)

  const syncSupplyPointProcess = async () => {
    setLoadingSync(true)

    try{
      await syncSupplyPoint();
      setLoadingSync(false)
      swal({
        title: `${t('Harga Berhasil Diperbarui')}`,
        icon: 'success',
      })
    }catch(err: any){
      setLoadingSync(false)
      swal({
        title: `${t('failed')}`,
        icon: 'error',
      })
    }
  }

  return (
    <>
      {!loading ? (
        <>
          <div className={`card ${className}`}>
            <div className='card-header'>
              <h3 className='card-title'>SAP</h3>
            </div>
            <div className='card-body'>
              {/* <Row className='mb-10'>
              <Col md={3}>
                <Form.Label>Plant</Form.Label>
                <div className="d-flex ">
                  <Button className='btn-sync' onClick={() => plantSynchro()}>Synchronize Plant</Button>
                  <Dropdown className=''>
                    <Dropdown.Toggle className="btn-sync-drop" id="dropdown-basic" />
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => plantTable()}>Table</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </Col>
            </Row> */}

              <div>
                <Row className='mb-4'>
                  <Col md={6}>
                    <div className='d-flex w-100'>
                      <Button
                        className='btn-sync w-75 me-1'
                        onClick={() => {
                          setFuncState('plant')
                          setShowApprove(true)
                          setModaltype('Plant')
                        }}
                        data-bs-toggle='tooltip'
                        data-bs-placement='top'
                        data-bs-trigger='hover'
                        title={t('Synchronize') + ' ' + t('kontrak-gudang')}
                      >
                        {t('Synchronize')} {t('kontrak-gudang')}
                      </Button>
                      <Dropdown className=''>
                        <Dropdown.Toggle
                          className='btn-sync-drop'
                          id='dropdown-basic'
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          data-bs-trigger='hover'
                          title={t('more')}
                        />
                        <Dropdown.Menu>
                          <Dropdown.Item onClick={() => plantTable()}>
                            {t('Table')} {t('kontrak-gudang')}
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className='d-flex w-100'>
                      <Button
                        className='btn-sync w-75 me-1'
                        onClick={() => {
                          setFuncState('area')
                          setShowApprove(true)
                          setModaltype('Sales Area')
                        }}
                        data-bs-toggle='tooltip'
                        data-bs-placement='top'
                        data-bs-trigger='hover'
                        title={t('Synchronize') + ' ' + t('Sales Area')}
                      >
                        {t('Synchronize')} {t('Sales Area')}
                      </Button>
                      <Dropdown className=''>
                        <Dropdown.Toggle
                          className='btn-sync-drop'
                          id='dropdown-basic'
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          data-bs-trigger='hover'
                          title={t('more')}
                        />
                        <Dropdown.Menu>
                          <Dropdown.Item onClick={() => areaTable()}>
                            {t('Table')} {t('Sales Area')}
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </Col>
                </Row>

                <Row className='mb-4'>
                  <Col md={6}>
                    <div className='d-flex w-100'>
                      <Button
                        className='btn-sync w-75 me-1'
                        onClick={() => {
                          setFuncState('material')
                          setShowApprove(true)
                          setModaltype('Material Product')
                        }}
                        data-bs-toggle='tooltip'
                        data-bs-placement='top'
                        data-bs-trigger='hover'
                        title={`${t('Synchronize')} Material`}
                      >
                        {t('Synchronize')} {t('Material Product')}
                      </Button>
                      <Dropdown className=''>
                        <Dropdown.Toggle
                          className='btn-sync-drop'
                          id='dropdown-basic'
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          data-bs-trigger='hover'
                          title={t('more')}
                        />
                        <Dropdown.Menu>
                          <Dropdown.Item onClick={() => materialTable()}>
                            {t('Table')} {t('Material Product')}
                          </Dropdown.Item>
                          <Dropdown.Item onClick={() => setShowMatNumber(true)}>
                            {t('Material Product')}
                          </Dropdown.Item>
                          <Dropdown.Item onClick={() => setShowMatDate(true)}>
                            {t('kontrak-tanggal')}
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className='d-flex w-100'>
                      <Button
                        className='btn-sync w-75 me-1'
                        onClick={() => {
                          setFuncState('office')
                          setShowApprove(true)
                          setModaltype('Sales Office')
                        }}
                        data-bs-toggle='tooltip'
                        data-bs-placement='top'
                        data-bs-trigger='hover'
                        title={t('Synchronize') + ' ' + t('Sales Office')}
                      >
                        {t('Synchronize')} {t('Sales Office')}
                      </Button>
                      <Dropdown className=''>
                        <Dropdown.Toggle
                          className='btn-sync-drop'
                          id='dropdown-basic'
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          data-bs-trigger='hover'
                          title={t('more')}
                        />
                        <Dropdown.Menu>
                          <Dropdown.Item onClick={() => officeTable()}>
                            {t('Table')} {t('Sales Office')}
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </Col>
                </Row>

                <Row className='mb-4'>
                  <Col md={6}>
                    <div className='d-flex w-100'>
                      <Button
                        className='btn-sync w-75 me-1'
                        onClick={() => {
                          setFuncState('customer')
                          setShowApprove(true)
                          setModaltype('Customer')
                        }}
                        data-bs-toggle='tooltip'
                        data-bs-placement='top'
                        data-bs-trigger='hover'
                        title={t('Synchronize') + ' ' + t('Customer')}
                      >
                        {t('Synchronize')} {t('Customer')}
                      </Button>
                      <Dropdown className=''>
                        <Dropdown.Toggle
                          className='btn-sync-drop'
                          id='dropdown-basic'
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          data-bs-trigger='hover'
                          title={t('more')}
                        />
                        <Dropdown.Menu>
                          <Dropdown.Item onClick={() => customerTable()}>
                            {t('Table')} {t('Customer')}
                          </Dropdown.Item>
                          <Dropdown.Item onClick={() => setShowCus(true)}>
                            {t('Customer')}
                          </Dropdown.Item>
                          <Dropdown.Item onClick={() => setShowCusDate(true)}>
                            {t('kontrak-tanggal')}
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className='d-flex w-100'>
                      <Button
                        className='btn-sync w-75 me-1'
                        onClick={() => {
                          setFuncState('Storage Location')
                          setShowApprove(true)
                          setModaltype('Storage Location')
                        }}
                        data-bs-toggle='tooltip'
                        data-bs-placement='top'
                        data-bs-trigger='hover'
                        title={t('Synchronize') + ' ' + t('Storage Location')}
                      >
                        {t('Synchronize')} {t('Storage Location')}
                      </Button>
                      <Dropdown className=''>
                        <Dropdown.Toggle
                          className='btn-sync-drop'
                          id='dropdown-basic'
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          data-bs-trigger='hover'
                          title={t('more')}
                        />
                        <Dropdown.Menu>
                          <Dropdown.Item onClick={() => storLocTable()}>
                            {t('Table')} {t('Storage Location')}
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </Col>
                </Row>

                <Row className='mb-4'>
                  <Col md={6}>
                    <div className='d-flex w-100'>
                      <Button
                        className='btn-sync w-75 me-1'
                        onClick={() => {
                          setFuncState('Bank Key')
                          setShowApprove(true)
                          setModaltype('Bank Key')
                        }}
                        data-bs-toggle='tooltip'
                        data-bs-placement='top'
                        data-bs-trigger='hover'
                        title={t('Synchronize') + ' ' + t('Bank Key')}
                      >
                        {t('Synchronize')} {t('Bank Key')}
                      </Button>
                      <Dropdown className=''>
                        <Dropdown.Toggle
                          className='btn-sync-drop'
                          id='dropdown-basic'
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          data-bs-trigger='hover'
                          title={t('more')}
                        />
                        <Dropdown.Menu>
                          <Dropdown.Item onClick={() => bankKeyTable()}>
                            {t('Table')} {t('Bank Key')}
                          </Dropdown.Item>
                          <Dropdown.Item onClick={() => setShowBank(true)}>
                            {t('kontrak-tanggal')}
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </Col>
                  <Col md={6}></Col>
                </Row>

                <Modal show={showCus} onHide={handleCloseCus} centered backdrop='static'>
                  <Modal.Header closeButton>
                    <Modal.Title>
                      {t('Synchronize')} {t('kontrak-pembeli')}
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Label>{t('Customer Code')}</Form.Label>
                    <Form.Control
                      type='number'
                      placeholder={t('Customer Code')}
                      onChange={(e: any) => setCusCode(e.target.value)}
                    />
                    <div className='d-flex justify-content-end mt-5'>
                      <button className='btn btn-primary' onClick={handleAddCus}>
                        {btnLoading ? (
                          <div className='d-flex justify-content-center align-items-center py-1'>
                            <Spinner animation='border' variant='light' size='sm' />
                          </div>
                        ) : (
                          <>{t('Synchronize')}</>
                        )}
                      </button>
                    </div>
                  </Modal.Body>
                </Modal>

                <Modal show={showCusDate} onHide={handleCloseCusDate} centered backdrop='static'>
                  <Modal.Header closeButton>
                    <Modal.Title>
                      {t('Synchronize')} {t('kontrak-pembeli')}
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Label>{t('From Date')}</Form.Label>
                    <Form.Control
                      type='date'
                      className='mb-3'
                      placeholder={t('From Date')}
                      onChange={(e: any) => setCusDate(e.target.value)}
                    />
                    <Form.Label>{t('order-tanggal-berakhir')}</Form.Label>
                    <Form.Control
                      type='date'
                      placeholder={t('order-tanggal-berakhir')}
                      onChange={(e: any) => setCusDatee(e.target.value)}
                    />
                    <div className='d-flex justify-content-end mt-5'>
                      <button className='btn btn-primary' onClick={handleAddCus}>
                        {btnLoading ? (
                          <div className='d-flex justify-content-center align-items-center py-1'>
                            <Spinner animation='border' variant='light' size='sm' />
                          </div>
                        ) : (
                          <>{t('Synchronize')}</>
                        )}
                      </button>
                    </div>
                  </Modal.Body>
                </Modal>

                <Modal
                  show={showBank}
                  onHide={() => {
                    setShowBank(false)
                    setCusDate('')
                    setCusDatee('')
                  }}
                  centered
                  backdrop='static'
                >
                  <Modal.Header closeButton>
                    <Modal.Title>
                      {t('Synchronize')} {t('Bank Key')}
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Label>{t('From Date')}</Form.Label>
                    <Form.Control
                      type='date'
                      className='mb-3'
                      placeholder={t('From Date')}
                      onChange={(e: any) => setCusDate(e.target.value)}
                    />
                    <Form.Label>{t('order-tanggal-berakhir')}</Form.Label>
                    <Form.Control
                      type='date'
                      placeholder={t('order-tanggal-berakhir')}
                      onChange={(e: any) => setCusDatee(e.target.value)}
                    />
                    <div className='d-flex justify-content-end mt-5'>
                      <button className='btn btn-primary' onClick={bankKeySyncrho}>
                        {btnLoading ? (
                          <div className='d-flex justify-content-center align-items-center py-1'>
                            <Spinner animation='border' variant='light' size='sm' />
                          </div>
                        ) : (
                          <>{t('Synchronize')}</>
                        )}
                      </button>
                    </div>
                  </Modal.Body>
                </Modal>
              </div>
            </div>
          </div>

          <div className={`card ${className}`}>
            <div className='card-header'>
              <h3 className='card-title'>WCM</h3>
            </div>
            <div className='card-body'>
              <div>
                  <Row className='mb-4'>
                    <Col md={6}>
                      <div className='d-flex w-100'>
                        <Button
                          className='btn-sync d-block w-75'
                          disabled={loadingSync}
                          onClick={() => syncSupplyPointProcess()}
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          data-bs-trigger='hover'
                          title={t('Synchronize') + ' ' + t('supply-point')}
                        >
                          { loadingSync && <i className="fas fa-sync-alt fa-spin"></i> }
                          <span>{t('Synchronize')} {t('supply-point')}</span>
                        </Button>
                      </div>
                    </Col>
                  </Row>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className='d-flex justify-content-center py-10' style={{marginTop: '15rem'}}>
            <div className='lds-ellipsis'>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </>
      )}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        scrollable
        backdrop='static'
        size='xl'
      >
        {showSkeletonModal ? (
          <div style={{padding: '3rem'}}>
            <SkeletonForm />
          </div>
        ) : (
          <>
            {modaltype == 'Plant' ? (
              <>
                <Modal.Header closeButton>
                  <Modal.Title>
                    {t('Table')} {t('kontrak-gudang')}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className='table-responsive bdr mt-5'>
                    <>
                      <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 border-bottom'>
                        <thead>
                          <tr className='fw-bold  d-flex jusify-content-center w-100 align-items-center'>
                            <th className='td-order-1 text-center'>{t('No')}</th>
                            <th className='td-order-3 text-center'>{t('nama')}</th>
                            <th className='td-order-3 text-center'>{t('City Code')}</th>
                            <th className='td-order-3 text-center'>{t('Address')}</th>
                            <th className='td-order-3 text-center'>{t('From Date')}</th>
                            <th className='td-order-3 text-center'>{t('To Date')}</th>
                          </tr>
                        </thead>
                      </table>
                      {allPlant.map((plants, _index) => (
                        <>
                          <table
                            className={`table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 ${
                              _index % 2 === 0 ? 'bg-secondary' : ''
                            }`}
                          >
                            <tr
                              className={`d-flex jusify-content-center w-100 align-items-center `}
                            >
                              <td className='view td-order-1 columnFlex'>
                                <div className='d-flex fs-6 py-3'>
                                  <button
                                    className='iconArow d-flex justify-content-center align-items-center me-2'
                                    data-target={'target' + (_index + 1) + (page * per - per)}
                                    data-bs-toggle='tooltip'
                                    data-bs-placement='top'
                                    data-bs-trigger='hover'
                                    title={t(tooltip)}
                                    onClick={handleOpen}
                                  >
                                    {/* <KTSVG path='/media/icons/duotune/arrows/arrow-down.svg' className='svg-1' /> */}
                                  </button>
                                  <p>{_index + 1 + (page * per - per)}</p>
                                </div>
                              </td>
                              <td className='td-order-3 text-center columnFlex'>
                                <div className='fs-6 py-3'>
                                  <PopoverText
                                    content={plants.name1 ? plants.name1 : '-'}
                                    index={_index}
                                    className='desc-slice'
                                  />
                                </div>
                              </td>
                              <td className='td-order-3 text-center columnFlex'>
                                <div className='fs-6 py-3'>{plants.city_code}</div>
                              </td>
                              <td className='td-order-3 text-center columnFlex'>
                                <div className='fs-6 py-3'>
                                  <PopoverText
                                    content={plants.address ? plants.address : '-'}
                                    index={_index}
                                    className='desc-slice'
                                  />
                                </div>
                              </td>
                              <td className='td-order-3 text-center columnFlex'>
                                <div className='fs-6 py-3'>{plants.from_date.slice(0, 10)}</div>
                              </td>
                              <td className='td-order-3 text-center columnFlex'>
                                <div className='fs-6 py-3'>{plants.to_date.slice(0, 10)}</div>
                              </td>
                            </tr>
                          </table>
                          <div className='d-flex justify-content-center lefttt'>
                            <div className='table-responsive sub-table'>
                              <table className='table'>
                                <tr
                                  className='fold'
                                  id={'target' + (_index + 1) + (page * per - per)}
                                >
                                  <td className='fold-wrapperContent'>
                                    <div className='fold-content' style={{padding: '0px'}}>
                                      <table className='table-border'>
                                        {/* begin::Table head */}
                                        <thead>
                                          <tr className='fw-bold border-bottom'>
                                            <th
                                              className='text-center'
                                              style={{padding: '1rem 2.5rem'}}
                                            >
                                              {t('kontrak-Gudang')}
                                            </th>
                                            <th
                                              className='text-center'
                                              style={{padding: '1rem 2.5rem'}}
                                            >
                                              {t('Assigment Id')}
                                            </th>
                                            <th
                                              className='text-center'
                                              style={{padding: '1rem 2.5rem'}}
                                            >
                                              {t('Assigment Sales Org Code')}
                                            </th>
                                            <th
                                              className='text-center'
                                              style={{padding: '1rem 2.5rem'}}
                                            >
                                              {t('Assigment Plant')}
                                            </th>
                                            <th
                                              className='text-center'
                                              style={{padding: '1rem 2.5rem'}}
                                            >
                                              {t('Assigment Distribution Channel')}
                                            </th>
                                            <th
                                              className='text-center'
                                              style={{padding: '1rem 2.5rem'}}
                                            >
                                              {t('Assigment Dc Description')}
                                            </th>
                                            <th
                                              className='text-center'
                                              style={{padding: '1rem 2.5rem'}}
                                            >
                                              {t('Assigment Plant Desc')}
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {plants['p_assignments']?.map(
                                            (subItem: any, index: number) => (
                                              <tr key={subItem?.id ?? index}>
                                                <td className='text-center'>{subItem.id}</td>
                                                <td className='text-center'>
                                                  {subItem.sales_org_code}
                                                </td>
                                                <td className='text-center'>{subItem.plant}</td>
                                                <td className='text-center'>
                                                  {subItem.distribution_channel}
                                                </td>
                                                <td className='text-center'>
                                                  {subItem.sales_org_desc}
                                                </td>
                                                <td className='text-center'>
                                                  {subItem.dc_description}
                                                </td>
                                                <td className='text-center'>
                                                  {subItem.plant_desc}
                                                </td>
                                              </tr>
                                            )
                                          )}
                                        </tbody>
                                        {/* end::Table body */}
                                      </table>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </div>
                          </div>
                        </>
                      ))}
                      <div className='mt-5'>
                        <Pagination paginate={paginateNumberPlant} test={numberURL} />
                      </div>
                    </>
                  </div>
                </Modal.Body>
              </>
            ) : (
              <></>
            )}

            {modaltype == 'Sales Area' ? (
              <>
                <Modal.Header closeButton>
                  <Modal.Title>
                    {t('Table')} {t('Sales Area')}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className='table-responsive bdr mt-5'>
                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                      <thead>
                        <tr className='fw-bold d-flex jusify-content-center w-100 align-items-center'>
                          <th className='td-order-1 text-center'>{t('No')}</th>
                          <th className='td-order-2 text-center'>{t('Sales Org Code')}</th>
                          <th className='td-order-3 text-center'>{t('Company Name')}</th>
                          <th className='td-order-2 text-center'>{t('Distribution Channel')}</th>
                          <th className='td-order-3 text-center'>{t('DC Description')}</th>
                          <th className='td-order-2 text-center'>{t('Division')}</th>
                          <th className='td-order-2 text-center'>
                            {t('Division') + ' ' + t('Description')}
                          </th>
                          <th className='td-order-3 text-center'>{t('Description')}</th>
                          <th className='td-order-3 text-center'>Id</th>
                          <th className='td-order-2 text-center'>{t('Sales Office Code')}</th>
                          <th className='td-order-2 text-center'>{t('From Date')}</th>
                          <th className='td-order-2 text-center'>{t('To Date')}</th>
                          <th className='td-order-2 text-center'>{t('Controlling Area')}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {allArea.map((areas, _index) => (
                          <table
                            key={areas?.id ?? _index}
                            className={`table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 ${
                              _index % 2 == 0 ? 'bg-secondary' : ''
                            } `}
                          >
                            <tr className='d-flex jusify-content-center w-100 align-items-center p-0'>
                              <td className='td-order-1 text-center columnFlex'>
                                <div className='fs-6 py-3'>{_index + 1 + (page * per - per)}</div>
                              </td>
                              <td className='td-order-2 text-center columnFlex'>
                                <div className='fs-6 py-3'>{areas.sales_org}</div>
                              </td>
                              <td className='td-order-3 text-center columnFlex'>
                                <div className='fs-6 py-3'>{areas.company_name}</div>
                              </td>
                              <td className='td-order-2 text-center columnFlex'>
                                <div className='fs-6 py-3'>{areas.distribution_channel}</div>
                              </td>
                              <td className='td-order-3 text-center columnFlex'>
                                <div className='fs-6 py-3'>{areas.dc_description}</div>
                              </td>
                              <td className='td-order-2 text-center columnFlex'>
                                <div className='fs-6 py-3'>{areas.division}</div>
                              </td>
                              <td className='td-order-2 text-center columnFlex'>
                                <div className='fs-6 py-3'>{areas.division_desc}</div>
                              </td>
                              <td className='td-order-3 text-center columnFlex'>
                                <div className='fs-6 py-3'>
                                  <PopoverText
                                    content={areas.description ? areas.description : '-'}
                                    index={_index}
                                    className='desc-slice'
                                  />
                                </div>
                              </td>
                              <td className='td-order-3 text-center columnFlex'>
                                <div className='fs-6 py-3'>
                                  <PopoverText
                                    content={
                                      areas.sales_office_detail.id
                                        ? areas.sales_office_detail.id
                                        : '-'
                                    }
                                    index={_index}
                                    className='desc-slice'
                                  />
                                </div>
                              </td>
                              <td className='td-order-2 text-center columnFlex'>
                                <div className='fs-6 py-3'>
                                  {areas.sales_office_detail.sales_office}
                                </div>
                              </td>
                              <td className='td-order-2 text-center columnFlex'>
                                <div className='fs-6 py-3'>
                                  {areas.sales_office_detail.from_date.slice(0, 10)}
                                </div>
                              </td>
                              <td className='td-order-2 text-center columnFlex'>
                                <div className='fs-6 py-3'>
                                  {areas.sales_office_detail.to_date.slice(0, 10)}
                                </div>
                              </td>
                              <td className='td-order-2 text-center columnFlex'>
                                <div className='fs-6 py-3'>
                                  {areas.sales_office_detail.controlling_area}
                                </div>
                              </td>
                            </tr>
                          </table>
                        ))}
                      </tbody>
                    </table>
                    <div className='mt-5'>
                      <Pagination paginate={paginateNumberArea} test={numberURL} />
                    </div>
                  </div>
                </Modal.Body>
              </>
            ) : (
              <></>
            )}

            {modaltype == 'Material Product' ? (
              <>
                <Modal.Header closeButton>
                  <Modal.Title>
                    {t('Table')} {t('Material Product')}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className='table-responsive bdr mt-10'>
                    <table className='table table-border table-row-gray-300 align-middle gs-0 gy-4 border-bottom'>
                      <thead>
                        <tr className='fw-bold d-flex jusify-content-center w-100 align-items-center border-bottom'>
                          <th className='td-order-1 text-center'>{t('No')}</th>
                          <th className='td-order-3 text-center'>{t('Material Group')}</th>
                          <th className='td-order-3 text-center'>{t('Material Number')}</th>
                          <th className='td-order-3 text-center'>{t('Company Code')}</th>
                          <th className='td-order-3 text-center'>{t('Plant Code')}</th>
                          <th className='td-order-3 text-center'>{t('Material Description')}</th>
                          <th className='td-order-3 text-center'>{t('Distribution Channel')}</th>
                          <th className='td-order-3 text-center'>{t('Plant Desc')}</th>
                        </tr>
                      </thead>

                      {allMaterial.map((materials: any, _index: any) => (
                        <>
                          {_index % 2 == 0 ? (
                            <tr className='d-flex jusify-content-center w-100 align-items-center bg-secondary'>
                              <td className='td-order-1 text-center'>
                                {_index + 1 + (page * per - per)}
                              </td>
                              <td className='td-order-3 text-center'>{materials.material_group}</td>
                              <td className='td-order-3 text-center'>
                                {materials.material_number}
                              </td>
                              <td className='td-order-3 text-center'>{materials.company_code}</td>
                              <td className='td-order-3 text-center'>{materials.plant}</td>
                              <td className='td-order-3 text-center'>
                                {materials.material_description}
                              </td>
                              <td className='td-order-3 text-center'>
                                {materials.distribution_channel}
                              </td>
                              <td className='td-order-3 text-center'>
                                {materials.plant_detail.name1}
                              </td>
                            </tr>
                          ) : (
                            <tr className='d-flex jusify-content-center w-100 align-items-center'>
                              <td className='td-order-1 text-center'>
                                {_index + 1 + (page * per - per)}
                              </td>
                              <td className='td-order-3 text-center'>{materials.material_group}</td>
                              <td className='td-order-3 text-center'>
                                {materials.material_number}
                              </td>
                              <td className='td-order-3 text-center'>{materials.company_code}</td>
                              <td className='td-order-3 text-center'>{materials.plant}</td>
                              <td className='td-order-3 text-center'>
                                {materials.material_description}
                              </td>
                              <td className='td-order-3 text-center'>
                                {materials.distribution_channel}
                              </td>
                              <td className='td-order-3 text-center'>
                                {materials.plant_detail.name1}
                              </td>
                            </tr>
                          )}
                        </>
                      ))}
                    </table>
                    <div className='mt-5'>
                      <Pagination paginate={paginateNumberMaterial} test={numberURL} />
                    </div>
                  </div>
                </Modal.Body>
              </>
            ) : (
              <></>
            )}

            {modaltype == 'Sales Office' ? (
              <>
                <Modal.Header closeButton>
                  <Modal.Title>
                    {t('Table')} {t('Sales Office')}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className='table-responsive bdr mt-10'>
                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 border-bottom'>
                      <thead>
                        <tr className='fw-bold d-flex jusify-content-center w-100 align-items-center'>
                          <th className='td-order-2 text-center'>{t('No')}</th>
                          <th className='td-order-3 text-center'>{t('Sales Office Code')}</th>
                          <th className='td-order-3 text-center'>{t('From Date')}</th>
                          <th className='td-order-3 text-center'>{t('To Date')}</th>
                          <th className='td-order-4 text-center'>{t('Controlling Area')}</th>
                        </tr>
                      </thead>
                    </table>

                    {allOffice.map((offices: any, _index: any) => (
                      <>
                        {_index % 2 == 0 ? (
                          <>
                            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 bg-secondary'>
                              <tr className='d-flex jusify-content-center w-100 align-items-center'>
                                <td className='view td-order-2 columnFlex'>
                                  <button
                                    className='iconArow d-flex justify-content-center align-items-center me-2'
                                    data-target={'target' + (_index + 1) + (page * per - per)}
                                    data-bs-toggle='tooltip'
                                    data-bs-placement='top'
                                    data-bs-trigger='hover'
                                    title={t(tooltip)}
                                    onClick={handleOpen}
                                  >
                                    {/* <KTSVG path='/media/icons/duotune/arrows/arrow-down.svg' className='svg-1' /> */}
                                  </button>
                                  <p>{_index + 1 + (page * per - per)}</p>
                                </td>
                                <td className='td-order-3 text-center columnFlex'>
                                  {offices.sales_office}
                                </td>
                                <td className='td-order-3 text-center columnFlex'>
                                  {offices.from_date.slice(0, 10)}
                                </td>
                                <td className='td-order-3 text-center columnFlex'>
                                  {offices.to_date.slice(0, 10)}
                                </td>
                                <td className='td-order-4 text-center columnFlex'>
                                  {offices.controlling_area}
                                </td>
                              </tr>
                            </table>
                            <div className='d-flex justify-content-center lefttt'>
                              <div className='table-responsive sub-table'>
                                <table className='table'>
                                  <tr
                                    className='fold'
                                    id={'target' + (_index + 1) + (page * per - per)}
                                  >
                                    <td className='fold-wrapperContent'>
                                      <div className='fold-content'>
                                        <table className='table-border'>
                                          {/* begin::Table head */}
                                          <thead>
                                            <tr className='fw-bold border-bottom'>
                                              <th
                                                className='text-center'
                                                style={{padding: '1rem 2.5rem'}}
                                              >
                                                Id
                                              </th>
                                              <th
                                                className='text-center'
                                                style={{padding: '1rem 2.5rem'}}
                                              >
                                                Sales Org
                                              </th>
                                              <th
                                                className='text-center'
                                                style={{padding: '1rem 2.5rem'}}
                                              >
                                                {t('Company Name')}
                                              </th>
                                              <th
                                                className='text-center'
                                                style={{padding: '1rem 2.5rem'}}
                                              >
                                                {t('Distribution Channel')}
                                              </th>
                                              <th
                                                className='text-center'
                                                style={{padding: '1rem 2.5rem'}}
                                              >
                                                {t('DC Description')}
                                              </th>
                                              <th
                                                className='text-center'
                                                style={{padding: '1rem 2.5rem'}}
                                              >
                                                {t('Division')}
                                              </th>
                                              <th
                                                className='text-center'
                                                style={{padding: '1rem 2.5rem'}}
                                              >
                                                {t('Division desc')}
                                              </th>
                                              <th
                                                className='text-center'
                                                style={{padding: '1rem 2.5rem'}}
                                              >
                                                {t('Sales Office')}
                                              </th>
                                              <th
                                                className='text-center'
                                                style={{padding: '1rem 2.5rem'}}
                                              >
                                                {t('Description')}
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {offices.sa_assignments?.map(
                                              (subItem: any, _index: number) => (
                                                <tr
                                                  key={subItem?.id ?? _index}
                                                  className='border-bottom'
                                                >
                                                  <td className='text-center'>{subItem.id}</td>
                                                  <td className='text-center'>
                                                    {subItem.sales_org}
                                                  </td>
                                                  <td className='text-center'>
                                                    {subItem.company_name}
                                                  </td>
                                                  <td className='text-center'>
                                                    {subItem.distribution_channel}
                                                  </td>
                                                  <td className='text-center'>
                                                    {subItem.division}
                                                  </td>
                                                  <td className='text-center'>
                                                    {subItem.dc_description}
                                                  </td>
                                                  <td className='text-center'>
                                                    {subItem.division_desc}
                                                  </td>
                                                  <td className='text-center'>
                                                    {subItem.sales_office}
                                                  </td>
                                                  <td className='text-center'>
                                                    {subItem.description}
                                                  </td>
                                                </tr>
                                              )
                                            )}
                                          </tbody>
                                          {/* end::Table body */}
                                        </table>
                                      </div>
                                    </td>
                                  </tr>
                                </table>
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                              <tr className='d-flex jusify-content-center w-100 align-items-center'>
                                <td className='view td-order-2 columnFlex'>
                                  <button
                                    className='iconArow d-flex justify-content-center align-items-center me-2'
                                    data-target={'target' + (_index + 1) + (page * per - per)}
                                    data-bs-toggle='tooltip'
                                    data-bs-placement='top'
                                    data-bs-trigger='hover'
                                    title={t(tooltip)}
                                    onClick={handleOpen}
                                  >
                                    {/* <KTSVG path='/media/icons/duotune/arrows/arrow-down.svg' className='svg-1' /> */}
                                  </button>
                                  <p>{_index + 1 + (page * per - per)}</p>
                                </td>
                                <td className='td-order-3 text-center columnFlex'>
                                  {offices.sales_office}
                                </td>
                                <td className='td-order-3 text-center columnFlex'>
                                  {offices.from_date.slice(0, 10)}
                                </td>
                                <td className='td-order-3 text-center columnFlex'>
                                  {offices.to_date.slice(0, 10)}
                                </td>
                                <td className='td-order-4 text-center columnFlex'>
                                  {offices.controlling_area}
                                </td>
                              </tr>
                            </table>
                            <div className='d-flex justify-content-center lefttt'>
                              <div className='table-responsive sub-table'>
                                <table className='table'>
                                  <tr
                                    className='fold'
                                    id={'target' + (_index + 1) + (page * per - per)}
                                  >
                                    <td className='fold-wrapperContent'>
                                      <div className='fold-content'>
                                        <table className='table-border'>
                                          {/* begin::Table head */}
                                          <thead>
                                            <tr className='fw-bold border-bottom'>
                                              <th
                                                className='text-center'
                                                style={{padding: '1rem 2.5rem'}}
                                              >
                                                Id
                                              </th>
                                              <th
                                                className='text-center'
                                                style={{padding: '1rem 2.5rem'}}
                                              >
                                                Sales Org
                                              </th>
                                              <th
                                                className='text-center'
                                                style={{padding: '1rem 2.5rem'}}
                                              >
                                                {t('Company Name')}
                                              </th>
                                              <th
                                                className='text-center'
                                                style={{padding: '1rem 2.5rem'}}
                                              >
                                                {t('Distribution Channel')}
                                              </th>
                                              <th
                                                className='text-center'
                                                style={{padding: '1rem 2.5rem'}}
                                              >
                                                {t('DC Description')}
                                              </th>
                                              <th
                                                className='text-center'
                                                style={{padding: '1rem 2.5rem'}}
                                              >
                                                {t('Division')}
                                              </th>
                                              <th
                                                className='text-center'
                                                style={{padding: '1rem 2.5rem'}}
                                              >
                                                {t('Division desc')}
                                              </th>
                                              <th
                                                className='text-center'
                                                style={{padding: '1rem 2.5rem'}}
                                              >
                                                {t('Sales Office')}
                                              </th>
                                              <th
                                                className='text-center'
                                                style={{padding: '1rem 2.5rem'}}
                                              >
                                                {t('Description')}
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {offices.sa_assignments?.map(
                                              (subItem: any, _index: number) => (
                                                <tr
                                                  key={subItem?.id ?? _index}
                                                  className='border-bottom'
                                                >
                                                  <td className='text-center'>{subItem.id}</td>
                                                  <td className='text-center'>
                                                    {subItem.sales_org}
                                                  </td>
                                                  <td className='text-center'>
                                                    {subItem.company_name}
                                                  </td>
                                                  <td className='text-center'>
                                                    {subItem.distribution_channel}
                                                  </td>
                                                  <td className='text-center'>
                                                    {subItem.division}
                                                  </td>
                                                  <td className='text-center'>
                                                    {subItem.dc_description}
                                                  </td>
                                                  <td className='text-center'>
                                                    {subItem.division_desc}
                                                  </td>
                                                  <td className='text-center'>
                                                    {subItem.sales_office}
                                                  </td>
                                                  <td className='text-center'>
                                                    {subItem.description}
                                                  </td>
                                                </tr>
                                              )
                                            )}
                                          </tbody>
                                          {/* end::Table body */}
                                        </table>
                                      </div>
                                    </td>
                                  </tr>
                                </table>
                              </div>
                            </div>
                          </>
                        )}
                      </>
                    ))}
                    <div className='mt-5'>
                      <Pagination paginate={paginateNumberOffice} test={numberURL} />
                    </div>
                  </div>
                </Modal.Body>
              </>
            ) : (
              <></>
            )}

            {modaltype == 'Customer' ? (
              <>
                <Modal.Header closeButton>
                  <Modal.Title>
                    {t('Table')} {modaltype}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className='table-responsive bdr mt-5'>
                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                      <thead>
                        <tr className='fw-bold d-flex jusify-content-center w-100 align-items-center'>
                          <th className='td-order-1 text-center'>{t('No')}</th>
                          <th className='td-order-3 text-center'>{t('Customer Code')}</th>
                          <th className='td-order-3 text-center'>{t('Name')}</th>
                          <th className='td-order-3 text-center'>{t('Customer Account Group')}</th>
                          <th className='td-order-3 text-center'>{t('text')}</th>
                          <th className='td-order-3 text-center'>{t('Company Type')}</th>
                          <th className='td-order-3 text-center'>
                            {t('Company Type Description 2')}
                          </th>
                          <th className='td-order-3 text-center'>{t('Address')}</th>
                          <th className='td-order-3 text-center'>{t('No Telp')}</th>
                          <th className='td-order-4 text-center'>Email</th>
                        </tr>
                      </thead>
                      <tbody>
                        {allCustomer.map((customers: any, _index: any) => (
                          <table
                            key={customers?.id ?? _index}
                            className={`table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 ${
                              _index % 2 == 0 ? 'bg-secondary' : ''
                            } `}
                          >
                            <tr className='d-flex jusify-content-center w-100 align-items-center p-0'>
                              <td className='td-order-1 text-center columnFlex'>
                                <div className='fs-6 py-3'>{_index + 1 + (page * per - per)}</div>
                              </td>
                              <td className='td-order-3 text-center columnFlex'>
                                <div className='fs-6 py-3'>{customers.customer_code}</div>
                              </td>
                              <td className='td-order-3 text-center columnFlex'>
                                <div className='fs-6 py-3'>
                                  {customers?.title == null
                                    ? customers?.name
                                    : customers?.title + '-' + customers?.name}
                                </div>
                              </td>
                              <td className='td-order-3 text-center columnFlex'>
                                <div className='fs-6 py-3'>{customers.customer_account_group}</div>
                              </td>
                              <td className='td-order-3 text-center columnFlex'>
                                <div className='fs-6 py-3'>{customers.text}</div>
                              </td>
                              <td className='td-order-3 text-center columnFlex'>
                                <div className='fs-6 py-3'>{customers.company_type}</div>
                              </td>
                              <td className='td-order-3 text-center columnFlex'>
                                <div className='fs-6 py-3'>
                                  {customers.company_type_description}
                                </div>
                              </td>
                              <td className='td-order-3 text-center columnFlex'>
                                <div className='fs-6 py-3'>
                                  <PopoverText
                                    content={
                                      customers.address?.street1 ? customers.address?.street1 : '-'
                                    }
                                    index={_index}
                                    className='desc-slice'
                                  />
                                </div>
                              </td>
                              <td className='td-order-3 text-center columnFlex'>
                                <div className='fs-6 py-3'>
                                  {customers.contact?.no_telp}
                                  <label className='opacity-0'>-</label>
                                </div>
                              </td>
                              <td className='td-order-4 text-center columnFlex'>
                                <div className='fs-6 py-3'>
                                  {customers.contact?.email}
                                  <label className='opacity-0'>-</label>
                                </div>
                              </td>
                            </tr>
                          </table>
                        ))}
                      </tbody>
                    </table>
                    <div className='mt-5' style={{height: '5rem'}}>
                      <Pagination paginate={paginateNumberCustomer} test={numberURL} />
                    </div>
                  </div>
                </Modal.Body>
              </>
            ) : (
              <></>
            )}

            {modaltype == 'Storage Location' ? (
              <>
                <Modal.Header closeButton>
                  <Modal.Title>
                    {t('Table')} {modaltype}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className='table-responsive bdr mt-5'>
                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                      <thead>
                        <tr className='fw-bold d-flex jusify-content-center w-100 align-items-center'>
                          <th className='td-order-1 text-center'>{t('No')}</th>
                          <th className='td-order-3 text-center'>{t('Plant')}</th>
                          <th className='td-order-4 text-center'>{t('Address')}</th>
                          <th className='td-order-3 text-center'>{t('Storage Location')}</th>
                          <th className='td-order-4 text-center'>{t('storage location desc')}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {allStorLoc.map((item: any, _index: any) => (
                          <>
                            <table
                              className={`table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 ${
                                _index % 2 === 0 ? 'bg-secondary' : ''
                              }`}
                            >
                              <tr className='d-flex jusify-content-center w-100 align-items-center p-0'>
                                <td className='td-order-1 text-center'>
                                  <div className='fs-6 py-3'>{_index + 1 + (page * per - per)}</div>
                                </td>
                                <td className='td-order-3 text-center'>
                                  <div className='fs-6 py-3'>{item.plant}</div>
                                </td>
                                <td className='td-order-4 text-center'>
                                  <div className='fs-6 py-3'>
                                    {item.plant_detail?.address}
                                    <label className='opacity-0'>-</label>
                                  </div>
                                </td>
                                <td className='td-order-3 text-center'>
                                  <div className='fs-6 py-3'>{item.sloc}</div>
                                </td>
                                <td className='td-order-4 text-center'>
                                  <div className='fs-6 py-3'>{item.sloc_description}</div>
                                </td>
                              </tr>
                            </table>
                          </>
                        ))}
                      </tbody>
                    </table>
                    <div className='mt-5' style={{height: '5rem'}}>
                      <Pagination paginate={paginateNumberCustomer} test={numberURL} />
                    </div>
                  </div>
                </Modal.Body>
              </>
            ) : (
              <></>
            )}

            {modaltype == 'Bank Key' ? (
              <>
                <Modal.Header closeButton>
                  <Modal.Title>
                    {t('Table')} {modaltype}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className='table-responsive bdr mt-5'>
                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                      <thead>
                        <tr className='fw-bold d-flex jusify-content-center w-100 align-items-center'>
                          <th className='td-order-1 text-center'>{t('No')}</th>
                          <th className='td-order-3 text-center'>{t('Id')}</th>
                          <th className='td-order-3 text-center'>{t('Bank Key')}</th>
                          <th className='td-order-3 text-center'>{t('Bank Name')}</th>
                          <th className='td-order-3 text-center'>{t('City')}</th>
                          <th className='td-order-3 text-center'>{t('Region')}</th>
                          <th className='td-order-3 text-center'>{t('Country Code')}</th>
                        </tr>
                        <tr className='fw-bold d-flex jusify-content-center w-100 align-items-center'>
                          <th className='td-order-1'></th>
                          <th className='td-order-3'>
                            <input className='form-control' onChange={(e: any) => setFilterBankKeyId(e.target?.value)}/>
                          </th>
                          <th className='td-order-3'>
                            <input className='form-control' onChange={(e: any) => setFilterBankKeyKey(e.target?.value)}/>
                          </th>
                          <th className='td-order-3'>
                            <input className='form-control' onChange={(e: any) => setFilterBankKeyName(e.target?.value)}/>
                          </th>
                          <th className='td-order-3'>
                            <input className='form-control' onChange={(e: any) => setFilterBankKeyCity(e.target?.value)}/>
                          </th>
                          <th className='td-order-3'>
                            <input className='form-control' onChange={(e: any) => setFilterBankKeyRegion(e.target?.value)}/>
                          </th>
                          <th className='td-order-3'>
                            <input className='form-control' onChange={(e: any) => setFilterBankKeyCountry(e.target?.value)}/>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {allBankKey.map((item: any, _index: any) => (
                          <>
                            <table
                              className={`table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 ${
                                _index % 2 === 0 ? 'bg-secondary' : ''
                              }`}
                            >
                              <tr className='d-flex jusify-content-center w-100 align-items-center p-0'>
                                <td className='td-order-1 text-center columnFlex'>
                                  <div className='fs-6 py-3'>{_index + 1 + (page * per - per)}</div>
                                </td>
                                <td className='td-order-3 text-center columnFlex'>
                                  <div className='fs-6 py-3'>
                                    <PopoverText
                                      content={item.id ? item.id : '-'}
                                      index={_index}
                                      className='desc-slice'
                                    />
                                  </div>
                                </td>
                                <td className='td-order-3 text-center columnFlex'>
                                  <div className='fs-6 py-3'>{item.bank_key}</div>
                                </td>
                                <td className='td-order-3 text-center columnFlex'>
                                  <div className='fs-6 py-3'>
                                    <PopoverText
                                      content={item.bank_name ? item.bank_name : '-'}
                                      index={_index}
                                      className='desc-slice'
                                    />
                                  </div>
                                </td>
                                <td className='td-order-3 text-center columnFlex'>
                                  <div className='fs-6 py-3'>
                                    {item.city}
                                    <label className='opacity-0'>-</label>
                                  </div>
                                </td>
                                <td className='td-order-3 text-center columnFlex'>
                                  <div className='fs-6 py-3'>
                                    {item.region_desc}
                                    <label className='opacity-0'>-</label>
                                  </div>
                                </td>
                                <td className='td-order-3 text-center columnFlex'>
                                  <div className='fs-6 py-3'>{item.country}</div>
                                </td>
                              </tr>
                            </table>
                          </>
                        ))}
                      </tbody>
                    </table>
                    <div className='mt-5' style={{height: '5rem'}}>
                      <Pagination paginate={paginateBankKey} test={numberURL} />
                    </div>
                  </div>
                </Modal.Body>
              </>
            ) : (
              <></>
            )}
          </>
        )}
      </Modal>

      <Modal show={showApprove} onHide={() => setShowApprove(false)} centered backdrop='static'>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <h3 className='text-center mb-5'>
            {t('Synchronize')} {t(modaltype)}?
          </h3>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant='secondary'
            disabled={isLoadingApproval}
            onClick={() => setShowApprove(false)}
          >
            {t('Tidak')}
          </Button>
          <AppButton
            variant='success'
            text={t('Ya')}
            isLoading={isLoadingApproval}
            disabled={isLoadingApproval}
            onClick={() => approvesynchro(funcState)}
          />
        </Modal.Footer>
      </Modal>

      <Modal
        show={showMatNumber}
        onHide={() => {
          setShowMatNumber(false)
          setMatNum('')
        }}
        centered
        backdrop='static'
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {t('Synchronize')} {t('Material Number')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Label>{t('Material Number')}</Form.Label>
          <Form.Control
            placeholder={t('Material Number')}
            onChange={(e: any) => setMatNum(e.target.value)}
          />
          <div className='d-flex justify-content-end mt-5'>
            <button
              className='btn btn-primary'
              disabled={btnLoading}
              onClick={() => materialsynchroParam(matNum, '', '')}
            >
              {btnLoading ? (
                <div className='d-flex justify-content-center align-items-center py-1'>
                  <Spinner animation='border' variant='light' size='sm' />
                </div>
              ) : (
                <>{t('Synchronize')}</>
              )}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showMatDate}
        onHide={() => {
          setShowMatDate(false)
          setMatDate1('')
          setMatDate2('')
        }}
        centered
        backdrop='static'
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {t('Synchronize')} {t('Material Product')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Label>{t('From Date')}</Form.Label>
          <Form.Control
            type='date'
            className='mb-3'
            placeholder={t('From Date')}
            onChange={(e: any) => setMatDate1(e.target.value)}
          />
          <Form.Label>{t('To Date')}</Form.Label>
          <Form.Control
            type='date'
            placeholder={t('To Date')}
            onChange={(e: any) => setMatDate2(e.target.value)}
          />
          <div className='d-flex justify-content-end mt-5'>
            <button
              className='btn btn-primary'
              disabled={btnLoading}
              onClick={() => materialsynchroParam('', matDate1, matDate2)}
            >
              {btnLoading ? (
                <div className='d-flex justify-content-center align-items-center py-1'>
                  <Spinner animation='border' variant='light' size='sm' />
                </div>
              ) : (
                <>{t('Synchronize')}</>
              )}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export {Synchronize}
